<template>
  <div
    v-if="sVisible"
    class="svj__modal"
  >
    <p class="svj-modal__header">
      {{activeIndex + 1}}/{{detail.imageList.length}}
      <a-icon type="close" @click="closeModal" class="svj-close"/>
    </p>
    <div class="svj-modal__swiper">
      <!-- swiper1 -->
      <swiper class="swiper" :options="swiperOptionTop" ref="swiper" @slide-change-transition-end="changeSlide">
        <swiper-slide
          v-for="(img, index) in detail.imageList"
          :key="index"
          :style="`backgroundImage: url(${img.imageUrl})`"
        ></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { Icon } from 'ant-design-vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'DetailModalMobile',
  components: {
    Swiper,
    SwiperSlide,
    'a-icon': Icon,
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: ['detail', 'visible', 'container'],
  watch: {
    visible(val) {
      this.sVisible = val;
    },
  },
  data() {
    return {
      sVisible: this.visible,
      activeIndex: 0,
      swiperOptionTop: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit('change', false);
    },
    changeSlide() {
      this.activeIndex = this.$refs.swiper.$swiper.activeIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/mixins/mobile.scss";

.svj__modal {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 100%;
  background-color: black;
  display: flex;
  align-items: center;
  .svj-modal__header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: vw(44);
    line-height: vw(44);
    color: #ffffff;
    font-size: vw(14);
    text-align: center;
  }
  .svj-close {
    position: absolute;
    left: 0;
    width: vw(50);
    height: vw(50);
    font-size: vw(14);
    color: white;
    line-height: vw(50);
  }
  .svj-modal__swiper {
    width: 100%;
    .swiper {
      height: vw(375);
      width: 100%;
      .swiper-slide {
        background-size: cover;
        background-position: center;
      }
    }
  }
}
</style>
